import { createContext, useContext } from 'react';

export type IdReferenceKind = 'workflow' | 'organization';

export interface ReferenceLookupValue {
  organizationId?: string;
  workflowId?: string;
  idReference?: IdReferenceKind;
  isWorkflowScope?: boolean;
}

export const ReferenceLookupContext = createContext<ReferenceLookupValue>({});

export const useReferenceLookup = (): ReferenceLookupValue => useContext(ReferenceLookupContext);
